import React, { useState, useEffect } from 'react';
import clsx from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import { makeStyles, withStyles, Typography, Grid, TextField, Button, Divider, Select, MenuItem, Checkbox, IconButton } from '@material-ui/core';import { ReactComponent as IconFilter } from 'assets/svgs/product_filter.svg';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    container: {
        padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
        backgroundColor: 'white',
        borderRadius: 15,
        margin: theme.spacing(3, 5)
    },
    label: {
        fontSize: 12,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        marginRight: 8,
    },
    dropIcon: {
        fill: theme.palette.app.primary
    },
    applybtn: {
        borderRadius: 12,
        backgroundColor: theme.palette.app.primary,
        color: 'white',
        "&:hover": {
            backgroundColor: theme.palette.app.fifth,
        },
        marginRight: theme.spacing(2)
    },
    filterIcon: {
        width: 24,
        height: 24
    },
    gridCell: {
        display: 'flex',
        alignItems: 'center'
    },
    filterBtn: {
        height: 38,
        marginLeft: theme.spacing(2),
        padding: theme.spacing(0.5, 2.5)
    },
    formControl: {
        minWidth: 300,
    },
    input: {
        '&:before': {
            borderBottomStyle: 'dashed',
        },
        '&:after': {
            borderBottomStyle: 'dashed',
        }
    },
    filterChips: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(1),
        minHeight: 38,
    },
    filterChip: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: theme.spacing(0.5, 1.5),
        borderRadius: 16,
        backgroundColor: theme.palette.grey[100],
        border: `1px solid ${theme.palette.grey[300]}`,
        fontSize: 13,
        lineHeight: 1.4,
        maxWidth: '100%',
    },
    filterChipLabel: {
        fontWeight: 600,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(0.5),
        whiteSpace: 'nowrap',
    },
    filterChipValue: {
        color: theme.palette.text.primary,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
}));

const ActiveFilterChips = ({ activeFilters, classes }) => {
    if (!activeFilters || activeFilters.length === 0) return null;
    return (
        <div className={classes.filterChips}>
            {activeFilters.map(({ key, label, value }) => (
                <span key={key || `${label}-${value}`} className={classes.filterChip}>
                    <span className={classes.filterChipLabel}>{label}:</span>
                    <span className={classes.filterChipValue}>{value}</span>
                </span>
            ))}
        </div>
    );
};

const SearchBar = ({ intl: { formatMessage },
    prefix,
    keyword,
    setKeyword,
    openFilter,
    setOpenFilter,
    containerStyle,
    rightComponent,
    placeholder,
    counts,
    hasFilter,
    showKeywordSearch = true,
    activeFilters,
}) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.container, containerStyle)}>
            <Grid
                container
                direction="row"
                alignItems="center"
                justify="space-between"
                spacing={1}
            >
                {
                    prefix &&
                    <Grid item xs={4}>
                        {prefix}
                    </Grid>
                }
                
                <Grid item xs className={classes.gridCell}>
                    {showKeywordSearch ? (
                    <>
                    <Typography className={classes.label}>{placeholder ? placeholder : <FormattedMessage id="table.filter.search" />}</Typography>
                    <Grid container alignItems="center" spacing={1}>
                        <Grid item xs>
                            <TextField label="" className={classes.formControl} InputProps={{ className: classes.input }}
                                value={keyword}
                                onChange={e => {
                                    e.persist()
                                    setKeyword(e.target.value)
                                }}
                            />
                        </Grid>
                        <Grid item>
                            {rightComponent}
                        </Grid>
                    </Grid>
                    </>
                    ) : (
                    <Grid container alignItems="center" justify="space-between" spacing={1}>
                        <Grid item xs>
                            <ActiveFilterChips activeFilters={activeFilters} classes={classes} />
                        </Grid>
                        <Grid item>
                            {rightComponent}
                        </Grid>
                    </Grid>
                    )}
                </Grid>
                
                <Grid item >
                    <Grid container justify="space-around" alignItems="center">
                        {
                            !openFilter && hasFilter &&
                            <Button className={classes.filterBtn} startIcon={<IconFilter className={classes.filterIcon} />} variant="outlined" size="small"
                                onClick={() => setOpenFilter(true)}
                            ><FormattedMessage id="table.filter.button" /></Button>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};
SearchBar.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }),
    prefix: PropTypes.any,
    keyword: PropTypes.string,
    setKeyword: PropTypes.func,
    openFilter: PropTypes.bool,
    setOpenFilter: PropTypes.func,
    containerStyle: PropTypes.any,
    rightComponent: PropTypes.any,
    placeholder: PropTypes.string,
    counts: PropTypes.any,
    hasFilter: PropTypes.bool,
    showKeywordSearch: PropTypes.bool,
    activeFilters: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })),
};
export default injectIntl(SearchBar);
